var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9939 21.1597C53.9248 19.2482 53.0962 17.4421 51.6899 16.1375L36.0454 1.89236L36.0409 1.88792C34.5809 0.588432 32.665 -0.0866394 30.7081 0.00892277C28.7512 0.104485 26.911 0.962987 25.586 2.39848L12.3449 16.5292C11.1545 15.9715 9.81626 15.8064 8.52494 16.0577C7.23361 16.309 6.05663 16.9636 5.1653 17.9264L1.64642 21.6764C0.533155 22.873 -0.0573796 24.4601 0.00440247 26.0892C0.0661845 27.7184 0.775237 29.2567 1.97597 30.3665L15.5806 42.6666C16.634 43.5979 17.9648 44.1607 19.37 44.269C20.7751 44.3774 22.1773 44.0253 23.3624 43.2666L29.3098 48.5722C30.3545 49.494 31.7031 50.0021 33.0996 50C33.1906 50 33.2817 50 33.3733 49.9939C34.8635 49.9271 36.2682 49.2826 37.2865 48.1983L41.503 43.6983C42.3238 42.7983 42.8377 41.6634 42.9715 40.4556C43.1053 39.2478 42.8521 38.0288 42.2481 36.9727L52.0859 26.3437C53.3865 24.9349 54.0726 23.0708 53.9939 21.1597V21.1597ZM36.1253 22.1425C36.1282 22.3933 36.0397 22.6367 35.8762 22.8275L21.4046 37.8366L20.4942 38.7421C20.3082 38.8994 20.0717 38.9852 19.8275 38.9837C19.5834 38.9823 19.3478 38.8938 19.1637 38.7343L5.68922 26.5331C5.55263 26.3723 5.47909 26.1678 5.48217 25.9572C5.48525 25.7467 5.56474 25.5444 5.70598 25.3876L9.06958 21.5403C9.24451 21.3761 9.47669 21.2857 9.71724 21.2883C9.95779 21.2909 10.188 21.3862 10.3593 21.5542L19.5223 29.7898L30.7492 18.2186C30.9459 18.0296 31.2089 17.9244 31.4824 17.9252C31.7558 17.926 32.0182 18.0329 32.2137 18.2231L35.8544 21.5359C36.002 21.6717 36.1002 21.8525 36.1337 22.0498L36.1269 22.0798L36.1253 22.1425ZM39.8402 26.0459C40.9709 24.8979 41.6198 23.3648 41.6549 21.7581V21.7331V21.7081C41.5476 20.0764 40.8082 18.5497 39.5922 17.4492L35.8533 13.9819L35.8471 13.9758C34.602 12.8582 32.9661 12.2706 31.2904 12.339C29.6147 12.4075 28.0328 13.1265 26.884 14.3419L19.2738 22.3375L16.5693 19.8408L29.4858 5.96129C29.8808 5.58179 30.4014 5.35869 30.9501 5.33383C31.4987 5.30898 32.0376 5.48408 32.4656 5.82629L48.0654 19.9731C48.2631 20.1511 48.4234 20.3663 48.5372 20.6061C48.6509 20.846 48.716 21.1059 48.7285 21.3708C48.741 21.6357 48.7007 21.9005 48.6101 22.15C48.5194 22.3994 48.38 22.6285 48.2 22.8242L34.8769 37.2282L37.6138 39.6549C37.6659 39.7139 37.6937 39.7902 37.6917 39.8686C37.6897 39.9471 37.6581 40.0219 37.6032 40.0782L33.3951 44.5988C33.3208 44.6614 33.2261 44.6947 33.1288 44.6924C33.0315 44.6902 32.9385 44.6525 32.8672 44.5866L27.1521 39.3716L39.8402 26.0459Z",
    fill: "url(#paint0_linear_2335_1780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_1780",
    x1: 0.000930263,
    y1: -0.000432179,
    x2: 53.9995,
    y2: -0.000432179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67C84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#60C261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4DB395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2F9AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D56EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E24CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E44CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E84CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EA4CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F74767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27c527ecad706c324db9297581c55a06.svg";
export { ForwardRef as ReactComponent };